module.exports = __webpack_public_path__ + "img/banner6.90f9e18d.png";